









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { ChangelogCollectionModel } from '@/modules/changelog/models/changelog-collection.model'
import QTable from 'quasar/src/components/table/QTable.js';
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import AdminChangelogInnerTableRow from '@/modules/changelog/components/admin/AdminChangelogInnerTableRow.vue'

@Component({
  components: {
    TesTable
  }
})
export default class AdminChangelogInnerTable extends Vue {
  @Prop({
    default: () => ({
      properties: {
        old: {},
        attributes: {}
      }
    })
  }) changelog!: ChangelogCollectionModel

  rowComponent = AdminChangelogInnerTableRow

  columns: QTable['columns'] = [
    {
      name: 'key',
      field: 'key',
      label: 'کلید',
      align: 'left'
    },
    {
      name: 'old',
      field: 'old',
      label: 'قدیم',
      align: 'left'
    },
    {
      name: 'attributes',
      field: 'attributes',
      label: 'جدید',
      align: 'left'
    }
  ]

  get tableData() {
    return this.keys.map(key => {
      return {
        key,
        attributes: this.changelog.properties.attributes[key],
        old: this.changelog.properties.old[key]
      }
    })
  }

  get keys() {
    return Object.keys(this.changelog.properties.attributes)
  }
}
